import React, { useEffect, useState } from 'react';
import { Alert, Button, Space, Upload, UploadProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useAppSelector } from '../../../app/hooks';

interface IProps {
  onSuccessfulSubmit: () => void;
  drawerVisible: boolean;
}

const ImportVehicleForm: React.FC<IProps> = ({ onSuccessfulSubmit, drawerVisible }: IProps) => {
  const token = useAppSelector((state) => state.auth.token);

  const [message, setMessage] = useState<string>();
  const [errors, setErrors] = useState<string[]>();

  const props: UploadProps = {
    name: 'file',
    listType: 'picture',
    maxCount: 1,
    multiple: false,
    action: `${process.env.REACT_APP_AUTOSTREAM_API ?? ''}/vehicles/csv/`,
    headers: {
      authorization: `Bearer ${token ?? ''}`,
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        setMessage(`${info.file.name} file uploaded successfully`);
        setErrors([]);
        // onSuccessfulSubmit();
      } else if (info.file.status === 'error') {
        setMessage('');
        setErrors(info.file.response?.errors);
      }
    },
    onRemove() {
      setErrors([]);
    },
  };

  useEffect(() => {
    if (!drawerVisible) {
      setMessage('');
      setErrors([]);
    }
  }, [drawerVisible]);

  return (
    <>
      <Space direction='vertical'>
        <Upload
          {...props}
          onRemove={() => {
            setErrors([]);
          }}
        >
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
        {message && (
          <>
            <Alert type='success' message={message} />
            <Button type='primary' onClick={onSuccessfulSubmit}>
              Go back to vehicle list
            </Button>
          </>
        )}
        <>
          {errors &&
            errors?.length > 0 &&
            errors?.map((error: any, index) => (
              <Alert key={index} type='error' message={error.errorMessage} showIcon />
            ))}
        </>
      </Space>
    </>
  );
};

export default ImportVehicleForm;
